/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { ButtonDividerProps } from './index';

/**
 * Base styles for the button divider component
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: ButtonDividerProps) => css`
    position: relative;
    min-height: 1px;

    &:after {
        content: ' ';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        border-bottom: 1px solid var(--colors-border-primary);
        z-index: 1;
    }

    .button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
    }

    ${smallTablet(css`
        .button {
            white-space: nowrap;
        }
    `)}
`;

/**
 * The ButtonDivider component styles
 *
 * @param {ButtonDividerProps} props The button divider properties object
 */
export const styles = (props: ButtonDividerProps) => css`
    ${baseStyles(props)}
`;
